import React from 'react';
import { salesPageData } from '../../data/salesPageData';
const FEATURED = [{
  title: 'Muebles de TV',
  text: 'Racks y centros de entretenimiento modernos.',
  image: salesPageData.images.tv,
  alt: 'Rack de TV moderno de madera y melamina blanca en un living contemporáneo'
}, {
  title: 'Cocinas',
  text: 'Alacenas, bajo mesadas, módulos y configuraciones.',
  image: salesPageData.images.kitchen,
  alt: 'Cocina moderna de melamina con alacenas, bajo mesadas e iluminación LED cálida'
}, {
  title: 'Placares y roperos',
  text: 'Soluciones de almacenamiento.',
  image: salesPageData.images.closet,
  alt: 'Vestidor a medida en melamina con estantes, barrales, cajones e iluminación LED'
}, {
  title: 'Escritorios',
  text: 'Home office y espacios reducidos.',
  image: salesPageData.images.desk,
  alt: 'Escritorio de estilo industrial con tapa de madera maciza y patas de hierro negro'
}];
const REST = [{
  title: 'Mesas de centro',
  text: 'Diseños funcionales y contemporáneos.'
}, {
  title: 'Repisas',
  text: 'Proyectos sencillos y decorativos.'
}, {
  title: 'Melamina',
  text: 'Proyectos funcionales y modernos.'
}, {
  title: 'Estilo industrial',
  text: 'Madera + metal.'
}, {
  title: 'Organizadores',
  text: 'Soluciones prácticas para espacios pequeños.'
}, {
  title: 'Muebles de baño',
  text: 'Muebles compactos y funcionales.'
}];
export function CategoriesBlock() {
  return <div id="incluye" className="relative border-t border-[#EFEDE8]/10 bg-[#181512]" data-id="element-319" data-mp="5k8l6c3gqp2l">
      <div className="mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-320" data-mp="l5gwtvb4mvo">
        <div className="mx-auto max-w-3xl text-center" data-id="element-321" data-mp="n8cdtf8b87s">
          <p className="font-display text-[10px] font-extrabold uppercase tracking-[0.24em] text-[#FF7A00]" data-id="element-322" data-mp="3sphd8zor7zer">
            Qué hay dentro de la Bóveda
          </p>
          <h2 className="title-glow reveal mt-4 font-display text-2xl font-black uppercase leading-[1.08] tracking-tight text-[#F8F3EA] sm:text-4xl" data-id="element-323" data-mp="1qx1k6agum36h">
            Más de 500 posibilidades para tu próximo proyecto
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-[#EFEDE8]/65 sm:text-base" data-id="element-324" data-mp="251sfd740fn1t">
            Desde proyectos simples para empezar hasta muebles de mayor complejidad.
          </p>
        </div>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-325" data-mp="1w386sys5ytrb">
          {FEATURED.map(cat => <li key={cat.title} className="reveal group overflow-hidden rounded-xl border border-[#EFEDE8]/10 bg-[#111111] transition-all duration-200 hover:-translate-y-1 hover:border-[#D89A3D]/40" data-id="element-326" data-mp="212b8c98xqhuj">
              <div className="aspect-[4/3] w-full overflow-hidden" data-id="element-327" data-mp="2srefbws7i6av">
                <img src={cat.image} alt={cat.alt} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" loading="lazy" width={1200} height={900} data-id="element-328" data-mp="2eswss2e1ezuj" />
              </div>
              <div className="p-5" data-id="element-329" data-mp="13cyd3foctfkc">
                <h3 className="font-display text-sm font-extrabold uppercase tracking-tight text-[#F8F3EA]" data-id="element-330" data-mp="13bwu8p13jos2">
                  {cat.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-[#EFEDE8]/60" data-id="element-331" data-mp="10sjwnh7j4lt4">
                  {cat.text}
                </p>
              </div>
            </li>)}
        </ul>

        <ul className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-332" data-mp="19trigzsuzu6b">
          {REST.map(cat => <li key={cat.title} className="reveal rounded-xl border border-[#EFEDE8]/10 bg-[#111111] p-5 transition-all duration-200 hover:-translate-y-1 hover:border-[#D89A3D]/40" data-id="element-333" data-mp="19rdqx0xe103i">
              <h3 className="font-display text-sm font-extrabold uppercase tracking-tight text-[#F8F3EA]" data-id="element-334" data-mp="h2zsik2e01rf">
                {cat.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-[#EFEDE8]/60" data-id="element-335" data-mp="qv5hrm19852x">
                {cat.text}
              </p>
            </li>)}
        </ul>

        <p className="reveal mt-8 text-center font-display text-xs font-extrabold uppercase tracking-[0.18em] text-[#D89A3D] sm:text-sm" data-id="element-336" data-mp="m22q5jg1f5pd">
          + Muchas otras categorías dentro de la Bóveda.
        </p>
      </div>
    </div>;
}